import React from "react";
import { ComponentAdditionPageInitialState, PageNewState } from ".";

export const ComponentAdditionPageContext = React.createContext({
  pageState: ComponentAdditionPageInitialState,
  setPageState: (pageState: PageNewState) => {},
});
